import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { ErrorBoundary, installGlobalErrorHandlers } from "./core/logging";
// Initialize i18n BEFORE the first render. Otherwise the i18n instance only
// initializes as a side-effect of whichever translated component's module graph
// happens to import it first, so the app shell can paint raw keys
// (nav.dashboard, NAV.SETTINGS) for a frame before re-rendering with real labels.
import i18n from "./core/i18n/i18n";
import { loadPluginI18nNamespaces } from "./core/i18n/load-plugin-namespaces";
import { clientPluginManifests } from "./core/plugins/client-plugin-registry";
import "./index.css";

installGlobalErrorHandlers();

// Register plugin i18n namespaces so plugin screens (analytics, site-content,
// billing, privacy, notifications, notes) resolve keys instead of raw paths.
loadPluginI18nNamespaces(clientPluginManifests);

function mount() {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
}

// Resources are statically bundled, so init is synchronous and this mounts
// immediately. The guard keeps it correct if an async resource backend is ever
// added (render waits for "initialized" instead of flashing keys).
if (i18n.isInitialized) {
  mount();
} else {
  i18n.on("initialized", mount);
}
